/**
 * Configuration Sentry centralisée pour toutes les apps Konstellation.
 * Les DSN sont lus depuis les variables d'environnement (jamais hardcodés).
 */

export type SiteId = 'remup' | 'info-av' | 'info-per' | 'flattax' | 'notaire' | 'valorup-app' | 'valorup-site';

/** Erreurs courantes à ignorer (extensions navigateur, resize observer, etc.) */
const IGNORED_ERRORS = [
  'ResizeObserver loop',
  'ResizeObserver loop completed with undelivered notifications',
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'adsbygoogle',
  'Non-Error promise rejection captured',
  'Load failed',
  'Failed to fetch',
  'NetworkError',
  'AbortError',
];

/** Filtre les erreurs provenant d'extensions navigateur */
function isExtensionError(event: { exception?: { values?: Array<{ stacktrace?: { frames?: Array<{ filename?: string }> } }> } }): boolean {
  const frames = event?.exception?.values?.[0]?.stacktrace?.frames;
  if (!frames) return false;
  return frames.some(
    (frame) =>
      frame.filename?.startsWith('chrome-extension://') ||
      frame.filename?.startsWith('moz-extension://') ||
      frame.filename?.startsWith('safari-extension://')
  );
}

interface SentryConfig {
  environment: string;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
  ignoreErrors: string[];
  enabled: boolean;
  beforeSend: (event: any) => any | null;
}

/**
 * Retourne la configuration Sentry commune pour un site donné.
 * L'environnement est détecté automatiquement.
 */
export function getSentryConfig(siteId: SiteId, env?: string): SentryConfig {
  const environment = env || 'production';
  const isProd = environment === 'production';

  return {
    environment,
    tracesSampleRate: isProd ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isProd ? 1.0 : 0,
    ignoreErrors: IGNORED_ERRORS,
    enabled: isProd,
    beforeSend(event) {
      if (isExtensionError(event)) return null;
      // Tag le site pour le filtrage dans le dashboard Sentry
      if (!event.tags) event.tags = {};
      event.tags.site = siteId;
      return event;
    },
  };
}
